import { GLServiceBase, ServiceRoute } from "commonui";
import { ComponentMediaSlotModel, IMediaTabService } from ".";

class MediaTabServiceClass extends GLServiceBase<any, any> implements IMediaTabService {
	serviceRoute: ServiceRoute = { prefix: "content/v1/versions" };

	getComponentMediaSlots(params: { componentId: string }): Promise<ComponentMediaSlotModel> {
		return this.get("component/{componentId}/slots", { params });
	}
}

export const MediaTabService = new MediaTabServiceClass();
